import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../auth/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authService.currentUserValue;
        let authToken = request.headers.get('Authorization');
        if (currentUser && currentUser.signInUserSession && authToken === null) {
            request = request.clone({
                setHeaders: {
                    Authorization: currentUser.signInUserSession.idToken.jwtToken
                }
            });
        }

        return next.handle(request);
    }
}